import _curry2 from "./internal/_curry2.js";
var max = _curry2(function max(a, b) {
    return b > a ? b : a;
});
export default max;
